import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";

export const useMaestras = () => {

    const [lineaConvocatorias, setLineaConvocatorias] = useState([]);
    const obtenerLineaConvocatorias = async() => {
        try {
            const lineasConvocatorias = await apiMaestras.obtenerLineaConvocatoria();
            setLineaConvocatorias(lineasConvocatorias);
        } catch (error) {
            console.log(error)
        }
    }

    const [entidades, setEntidades] = useState<any>([]);
    const obtenerEntidades = async() => {
        try {
            const entidades = await apiMaestras.obtenerEntidades();
            return setEntidades(entidades);
        } catch (error) {
            console.log(error)
        }
    }

    const [ciclos, setCiclos] = useState<any>([]);
    const obtenerCiclos = async() => {
        try {
            const ciclos = await apiMaestras.obtenerCiclos();
            setCiclos(ciclos);
        } catch (error) {
            console.log(error)
        }
    }

    const [lineaEstrategica, setLineaEstrategica] = useState<any>([]);
    const obtenerLineaEstrategica = async() => {
        try {
            const lineaEstrategica = await apiMaestras.obtenerLineaEstrategicas();
            setLineaEstrategica(lineaEstrategica);
        } catch (error) {
            console.log(error)
        }
    }

    const [areas, setAreas] = useState<any>([]);
    const obtenerAreas = async() => {
        try {
            const areas = await apiMaestras.obtenerAreas();
            setAreas(areas);
        } catch (error) {
            console.log(error)
        }
    }

    const [documentosAdmins, setDocumentosAdmins] = useState<any>([]);
    const obtenerDocAdmin = async() => {
        try {
            const docAdmins = await apiMaestras.obtenerDocumentosAdminsitrativos();
            let docMap = docAdmins.map((x : any) => {
                return {
                    id: x.id,
                    documento: x.documento,
                    tipo_participante_id: ({"Persona natural": 1, "Persona juridica": 2} as Record<string,number>)[x.tipo_participante] ?? 3
                }
            })
            docMap = docMap.sort(function (a, b) {
                if (a.id > b.id) {
                  return 1;
                }
                if (a.id < b.id) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });
            setDocumentosAdmins(docMap);
        } catch (error) {
            console.log(error);
        }
    }

    const [documentosTecnicos, setDocumentosTecnicos] = useState<any>([]);
    const obtenerDocTec = async() => {
        try {
            const docTecn = await apiMaestras.obtenerDocumentosTecnicos();
            setDocumentosTecnicos(docTecn);
        } catch (error) {
            console.log(error);
        }
    }

    const [documentosGenerales, setDocumentosGenerales] = useState<any>([]);
    const obtenerDocGen = async() => {
        try {
            const docGen = await apiMaestras.obtenerDocGen();
            setDocumentosGenerales(docGen);
        } catch (error) {
            console.log(error);
        }
    }

    const [criterios, setCriterios] = useState<any>([]);
    const obtenerCriterios = async() => {
        try {
            const criterios = await apiMaestras.obtenerCriterios();
            setCriterios(criterios);
        } catch (error) {
            console.log(error);
        }
    }


    return {
        obtenerLineaConvocatorias,
        lineaConvocatorias,
        obtenerEntidades,
        entidades,
        obtenerCiclos,
        ciclos,
        obtenerLineaEstrategica,
        lineaEstrategica,
        obtenerAreas,
        areas,
        obtenerDocAdmin,
        documentosAdmins,
        obtenerDocTec,
        documentosTecnicos,
        obtenerCriterios,
        criterios,
        obtenerDocGen,
        documentosGenerales
    }
}
